<template>
<div>
  <vx-card class="mb-8">

    <vs-row class=" w-full mb-4">
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>기안자</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-10/12 pl-2"></vs-input>
        </vs-col>
      </vs-col>
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title-normal"><h5>양식명</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-10/12 pl-2"></vs-input>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>문서제목</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-10/12 pl-2"></vs-input>
        </vs-col>
      </vs-col>
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title-normal"><h5>기안일</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <date-selector class="w-3/12"></date-selector>
          <span class="mx-4">~</span>
          <date-selector class="w-3/12"></date-selector>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>문서번호</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-10/12 pl-2"></vs-input>
        </vs-col>
      </vs-col>
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title-normal"><h5>문서상태</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-10/12 pl-2"></vs-input>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row class=" w-full mb-4">
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title"><h5>기안부서</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <vs-input class="w-10/12 pl-2"></vs-input>
        </vs-col>
      </vs-col>
      <vs-col class="w-1/2" vs-type="flex" vs-align="center">
        <vs-col class="fix-title-normal"><h5>완료일</h5></vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-justify="left">
          <date-selector class="w-3/12"></date-selector>
          <span class="mx-4">~</span>
          <date-selector class="w-3/12"></date-selector>
        </vs-col>
      </vs-col>
    </vs-row>
  </vx-card>

  <vs-table
    class="pb-wide"

    ref="table"
    stripe
    :data="documentList"
    :sst="true"
    color="success">

    <template slot="header" >

      <div class="mb-6 flex flex-wrap-reverse items-center flex-grow justify-between ">
        <!--
        [Per Page] : 한 페이지에 보여지는 게시글 수를 설정하는 드롭다운
        드롭다운에 노출되는 아이템을 추가하려면, props.perPage 에 콤마(,)로 구분하여 넣으면 된다.

        ex) per-page="10,20,30"
      -->
        <vs-select
          autocomplete
          v-model="boardPerPage"
          class="fix-perpage">
          <vs-select-item :key="index" :value="item.value" :text="item.text"
                          v-for="(item,index) in itemsPerPageOptions"/>
        </vs-select>

        <vs-col class="ml-auto w-6/12" vs-type="flex">
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="ArrowRightIcon" style="background-color: #7E72F2; color:#fff; margin-right:4px; width:24px; padding-left:4px; padding-right:4px; border-radius: 50%;"/>
            진행중
          </vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="CheckIcon" style="background-color: #28C76F; color:#fff; margin-right:4px; width:24px; padding-left:4px; padding-right:4px; border-radius: 50%;"/>
            완료
          </vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="XIcon" style="background-color: #EA5455; color:#fff; margin-right:4px; width:24px; padding-left:4px; padding-right:4px; border-radius: 50%;"/>
            반려
          </vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="RotateCcwIcon" style="background-color: #FF9F43; color:#fff; margin-right:4px; width:24px; padding-left:4px; padding-right:4px; border-radius: 50%;"/>
            회수
          </vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="ClockIcon" style="background-color: #BBBBBB; color:#fff; margin-right:4px; width:24px; padding-left:4px; padding-right:4px; border-radius: 50%;"/>
            대기
          </vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="LockIcon" style="color:#6670CB;" />
            보안설정
          </vs-col>
          <vs-col vs-type="flex" vs-align="center">
            <feather-icon icon="UnlockIcon" style="color:#6670CB;" />
            보안해제
          </vs-col>
        </vs-col>
      </div>
    </template>

    <template slot="thead">
      <vs-th >서식함</vs-th>
      <vs-th >문서번호</vs-th>
      <vs-th >유형</vs-th>
      <vs-th >문서제목</vs-th>
      <vs-th >기안자</vs-th>
      <vs-th >기안부서</vs-th>
      <vs-th >기안일</vs-th>
      <vs-th >완료일</vs-th>
      <vs-th >보안설정</vs-th>
      <vs-th >문서상태</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">


        <vs-td >서식함</vs-td>
        <vs-td >문서번호</vs-td>
        <vs-td >유형</vs-td>
        <vs-td >문서제목</vs-td>
        <vs-td >기안자</vs-td>
        <vs-td >기안부서</vs-td>
        <vs-td >기안일</vs-td>
        <vs-td >완료일</vs-td>
        <vs-td >보안설정</vs-td>
        <vs-td >문서상태</vs-td>

      </vs-tr>
    </template>
  </vs-table>

  <div class="w-full text-right">
    <vs-button class="w-2/12" color="secondary">알림권한</vs-button>
  </div>

  <div class="vs-con-table">
    <div class="con-pagination-table vs-table--pagination">
      <k-pagination
        :total="(lastPage) ? lastPage : 1"
        v-model="boardCurrentPage" ></k-pagination>
    </div>
  </div>
</div>
</template>

<script>
import DateSelector from '@/views/components/DateSelector'
import KPagination from '@/views/components/kPagination/kPagination'

export default {
  name: 'Document',
  components: {
    KPagination,
    DateSelector
  },
  data () {
    return {
      boardPerPage: 10,
      itemsPerPageOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 }
      ],
      documentList: [],
      lastPage: 10,
      boardCurrentPage : 1
    }
  }
}
</script>

<style scoped>
.fix-title { width:120px !important; }
.fix-title-normal { width:80px !important; }
.fix-title-small { width:40px !important; }
.fix-perpage { width:110px; }

</style>
